// extracted by mini-css-extract-plugin
export default {"header":"AuthHeader_header__+EnVi","name":"AuthHeader_name__K8GUI"};